import { render } from "./CustomAppError.vue?vue&type=template&id=271af733"
import script from "./CustomAppError.vue?vue&type=script&lang=js"
export * from "./CustomAppError.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"CustomAppError.vue"]])

export default __exports__